<div class="subcategory-picker"
     [attr.data-number-of-columns]="getNumberOfColumns()"
     [attr.data-only-option]="selectionCount == 1">
  <div *ngFor="let category of categories"
       class="subcategory-picker-column"
       [ngClass]="category.value.length > 13 ? 'column-2': ''">
    <div class="subcategory-picker-column-header">
      {{category.key}}
    </div>

    <div class="subcategory-picker-column-body">
      <div *ngFor="let subcategory of category.value"
           (click)="$event.stopPropagation(); subcategoryFound.emit(subcategory.id)"
           class="subcategory-picker-column-body-entry"
           [attr.data-selected]="selected(subcategory.name)">
        {{subcategory.name}}
      </div>
    </div>
  </div>
</div>
